// extracted by mini-css-extract-plugin
var _1 = "l6Z8JM3mch";
export { _1 as "placeholder" }
